import { observer } from "mobx-react";
import React from "react";

type Props = {
	headline: any;
	anchor: string | undefined;
};

type State = {
	accordionOpen: boolean;
};

@observer
class Accordion extends React.Component<Props, State> {
	// set initial state in constructor directly
	state = {
		accordionOpen: true,
	};

	render() {
		return (
			<div className={`accordion-step ${this.state.accordionOpen ? "open" : ""}`} id={this.props.anchor}>
				<div className="step-header">
					<button
						className="btn-step"
						onClick={() => {
							this.setState({ accordionOpen: !this.state.accordionOpen });
						}}
					>
						{this.props.headline}
					</button>
				</div>
				{this.props.children}
			</div>
		);
	}
}

export default Accordion;
